import React, { memo } from "react";
import styled from "styled-components";

interface ICommercialTitleProps {
  title: string;
  icon?: any;
}

const TitleDisplay = styled.div`
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  color: ${(props) => props.theme.textColorDarken};

  &.has-icon {
    padding-left: 20px;

    &:before {
      content: " ";
    }
  }
`;

const Title = (props: ICommercialTitleProps) => {
  return (
    <TitleDisplay data-test="commercial-title">
      {props.icon ? props.icon : ""}
      {props.title}
    </TitleDisplay>
  );
};

export const CommercialTitle = memo(Title);
